import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const ProgressStepAdv = {
    name: 'ProgressStepAdv',
    state: {
        steps: {
            0: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 0, label: '' },
            1: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 85, label: 'Campaign' },
            2: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 10, label: 'Avatar' },
            3: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 5, label: 'Add User' },
        },
        step: 0,
        completed: false,
        newData: {},
    },
    reducers: {
        progressRequested(state) {
            return { ...state, step: 0, completed: false };
        },
        progressCompleted(state) {
            return { ...state, completed: true };
        },
        setData(state, payload) {
            return { ...state, newData: payload };
        },
        stepSkipped(state, payload) {
            const newSteps = { ...state.steps, [payload]: { ...state.steps[payload] } };
            newSteps[payload].isSkipped = true;
            return { ...state, step: payload, steps: newSteps };
        },
        progressReveived(state, payload, check) {
            const newSteps = { ...state.steps, [payload]: { ...state.steps[payload] } };
            const newData = state.newData;
            if (check === 'update') {
                Object.keys(newSteps).forEach(key => {
                    newSteps[key].isActive = false;
                });
                newSteps[payload].isActive = true;
            } else if (check === 'delete') {
                newSteps[payload].isCompleted = false;
                newSteps[payload].isDisable = false;
            } else if (check === 'get') {
                newSteps[payload].isCompleted = true;
                newSteps[payload].isDisable = true;
                newSteps[payload].isActive = false;
            } else if (check === 'skipped') {
                newSteps[payload].isCompleted = true;
                newSteps[payload].isDisable = true;
                newSteps[payload].isActive = false;
                newSteps[payload].isSkipped = true;
            }
            else if (check === 'skip' && newData.isUserSkipped) {
                newSteps[payload].isCompleted = true;
                newSteps[payload].isDisable = true;
                newSteps[payload].isActive = false;
                newSteps[payload].isSkipped = true;
            }
            const completedSteps = Object.keys(newSteps).filter(key => newSteps[key].isCompleted).length;
            const isCompleted = completedSteps === 3;

            return { ...state, step: payload, steps: newSteps, completed: isCompleted };

        },

        progressFailed(state, payload) {
            return { ...state, step: state.step, steps: state.steps, completed: false };
        },

        clearMessages(state) {
            return {
                ...state, step: 0, completed: false
            };
        },
    },
    effects: (dispatch) => ({
        async GetADVProgressStep() {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const adv_id = userInfo?.org_id;
                const orgId = userInfo?.org_id;
                const campaignsUrl = `savvy/campaigns/${adv_id}?page=1&size=10`;
                const usersUrl = `savvy/users/countUsers/${orgId}`;
                const avatarUrl = `savvy/users/verifyConnect/${orgId}`;


                const response = await http.get(campaignsUrl);
                if (response && response?.data?.data?.rows) {
                    const { data } = response.data;
                    if (data && data?.rows?.length > 0) {
                        this.progressReveived(1, 'get');
                    } else {
                        this.progressFailed('No data available');
                    }
                }
                const avatarResponse = await http.get(avatarUrl);
                if (avatarResponse && avatarResponse?.data) {
                    const { data } = avatarResponse.data;
                    if (data && data?.avatar) {
                        this.progressReveived(2, 'get');
                    }
                }
                const usersResponse = await http.get(usersUrl);
                if (usersResponse && usersResponse?.data) {
                    const { data } = usersResponse.data;
                    if (data && data.count > 1) {
                        this.progressReveived(3, 'get');
                    } else {
                        const { data } = avatarResponse?.data;
                        this.setData(data);
                        this.progressReveived(3, 'skip');
                    }
                }
                else {
                    this.progressFailed('No data available');
                }
            }
            catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async UpdateADVProgressStep(newStep) {
            try {
                this.progressReveived(newStep, 'update');
            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async DeleteADVProgressStep(newStep) {
            try {
                this.progressReveived(newStep, 'delete');
                const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
                storedUserInfo.isProfileCompleted = false;
                localStorage.setItem('userInfo', JSON.stringify(storedUserInfo));
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async SkippedADVProgressStep(newStep) {
            try {
                this.progressReveived(newStep, 'skipped');
            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async UpdateGetADVProgressStep(newStep) {
            try {
                this.progressReveived(newStep, 'get');
            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async UpdateProfileSkipped(data) {
            try {
                const { id, isUserSkipped } = data;
                const url = `savvy/users/updateSkipped/${id}`;
                await http.put(url, { isUserSkipped });

            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async UpdateProfileProgress(score) {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const id = userInfo?.id;
                const url = `savvy/users/updateScore/${id}`;

                const response = await http.put(url, { score });
                if (response && response.data) {
                    const { data } = response.data;
                    if (data) {
                        const storedUserInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
                        storedUserInfo.isProfileCompleted = response.data.data.isProfileCompleted;
                        localStorage.setItem('userInfo', JSON.stringify(storedUserInfo));
                    } else {
                        this.progressFailed('No data available');
                    }
                }

            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async clearStateMessages() {
            this.clearMessages();
        },
    }),
};

export default ProgressStepAdv;